import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import EdiTable from '../../../components/Editable';

export default function Comentarios({ visible, onOk, onCancel, comentarios }) {
  const [dataSource, setDataSource] = useState([]);

  const updateDataSource = (dataSourceParam) => {
    setDataSource(dataSourceParam);
  };

  useEffect(() => {
    setDataSource(comentarios);
  }, [comentarios]);

  return (
    <Modal
      title="Comentario"
      open={visible}
      closable={false}
      width={1000}
      onOk={() => {
        let newDataSource = [];
        if (dataSource) {
          newDataSource = dataSource.filter((item) => item.pieza);
          setDataSource(newDataSource);
        }
        onOk(newDataSource);
      }}
      onCancel={onCancel}
    >
      <EdiTable setDatasource={updateDataSource} datasource={dataSource} />
    </Modal>
  );
}
